import React from 'react';
import {Dialog} from 'primereact/dialog';

import styles from './auth.module.css';
import {SignUpForm} from '../../domains/signUpForm';
import {useAuth} from './auth-provider';

export const SignUpDialog = () => {
  const {
    signupVisible,
    closeSignUpModal,
  } = useAuth();

  return (
    <Dialog
      header="Регистрация"
      visible={signupVisible}
      style={{width: '50vw'}}
      onHide={() => {
        if (!signupVisible) return;
        closeSignUpModal();
      }}
      pt={{
        header: {
          className: styles.cardWrapper,
        },
        content: {
          className: styles.cardWrapper,
        },
        footer: {
          className: styles.cardWrapper,
        },
      }}
    >
      <SignUpForm />
    </Dialog>
  );
}
